module.exports = __webpack_public_path__ + "img/animation-airplane.fd7b451d.gif";